module.exports = __webpack_public_path__ + "img/team.8f4846fe.svg";